export enum OfferKind {
  JOB = "job",
  SOCIAL = "social",
  TRAINING = "training",
}

export enum TrainingOfferModality {
  QUALIFYING = "qualifying",
  CERTIFYING = "certifying",
  FACE_TO_FACE = "face-to-face",
  FULL_REMOTE = "full-remote",
  PAID = "paid",
  UNPAID = "unpaid",
}

export enum InternalOfferSource {
  BIMBAMJOB = "BimBamJob",
  BBJ_ASSISTANT = "BBJ-Assistant",
}

const INTERNAL_OFFER_SOURCES = Object.values(InternalOfferSource).map((source) => source.toLowerCase());

export const isInternalOfferSource = (source: string | null | undefined) =>
  Boolean(source && INTERNAL_OFFER_SOURCES.includes(source.toLowerCase()));

export const toSettingOfferSource = <T extends string | null | undefined>(source: T) =>
  isInternalOfferSource(source) ? InternalOfferSource.BIMBAMJOB : source;
